// Runtime config injected by docker-entrypoint.sh via /config.js.
// In local dev (npm start) window.ENV is empty and the REACT_APP_* env vars
// from .env.development.local are used as fallback.

declare global {
  interface Window {
    ENV?: {
      API_URL?: string;
      ENTRA_TENANT_ID?: string;
      ENTRA_CLIENT_ID?: string;
      ALLOWED_EMAIL_DOMAIN?: string;
    };
  }
}

export const getApiUrl = (): string =>
  window.ENV?.API_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:5280";

export const getEntraTenantId = (): string =>
  window.ENV?.ENTRA_TENANT_ID ||
  process.env.REACT_APP_ENTRA_TENANT_ID ||
  "common";

export const getEntraClientId = (): string =>
  window.ENV?.ENTRA_CLIENT_ID ||
  process.env.REACT_APP_ENTRA_CLIENT_ID ||
  "00000000-0000-0000-0000-000000000000";
